module.exports = __webpack_public_path__ + "static/papaw-49b09c6689f3498a7885c7310d7ab8fa.jpg";